import { useQueryClient } from '@tanstack/react-query'

export const useLogout = () => {
  const queryClient = useQueryClient()
  const clearCache = () => {
    queryClient.clear()
  }
  return { clearCache }
}
